import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "about-us-content" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "article-content" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "h2-title" }
const _hoisted_6 = { class: "introduce" }
const _hoisted_7 = { class: "advantage-content" }
const _hoisted_8 = { class: "top" }
const _hoisted_9 = { class: "bottom" }
const _hoisted_10 = { class: "img" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "img" }
const _hoisted_13 = { class: "img" }
const _hoisted_14 = { class: "text" }

import NavBar from '@/components/NavBar.vue';
import Footer from '@/components/Footer.vue';
import { UtilMethods } from '@/util/UtilMethods';
import { useI18n } from 'vue-i18n';
import { BreadType, LanguagePackageType } from '@/typeDefine/EntityType';
import { LanguageType } from '@/typeDefine/CommonTypes';
import Breadcrumb from '@/components/Breadcrumb.vue';
import companyImage from '@/assets/images/companyImage.png'


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutUs',
  setup(__props) {

const { t } = useI18n<[LanguagePackageType], LanguageType>()

const maxZIndex: string = UtilMethods.getDOMStyleFromCSS('--max-z-index')

//面包屑地址
const breadList: BreadType[] = [
    {
        text: 'index.navBar.aboutUs'
    }
]

return (_ctx: any,_cache: any) => {
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, { "z-index": _unref(maxZIndex) }, {
      default: _withCtx(() => [
        _createVNode(NavBar)
      ]),
      _: 1
    }, 8, ["z-index"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Breadcrumb, { "bread-list": breadList }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('aboutUs.articleTitle')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.$tm('aboutUs.articleContentList') as any), (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.h2Title), 1),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.introduce, (p, pIndex) => {
                return (_openBlock(), _createElementBlock("p", { key: pIndex }, _toDisplayString(p), 1))
              }), 128))
            ])
          ], 64))
        }), 128)),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.$tm('index.advantage') as any), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "advantage-item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.top), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(item.bottom), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_image, {
            src: _unref(companyImage),
            fit: "contain",
            style: {"max-height":"500px"}
          }, null, 8, ["src"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.$tm('aboutUs.illustration') as any), (item, index) => {
          return (_openBlock(), _createBlock(_component_el_row, {
            align: 'middle',
            gutter: 20
          }, {
            default: _withCtx(() => [
              (index % 2 === 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(item.tips), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_el_image, {
                            src: item.image,
                            fit: "contain",
                            style: {"max-height":"500px"}
                          }, null, 8, ["src"])
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _createVNode(_component_el_image, {
                            src: item.image,
                            fit: "contain",
                            style: {"max-height":"500px"}
                          }, null, 8, ["src"])
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(item.tips), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ], 64))
            ]),
            _: 2
          }, 1024))
        }), 256))
      ])
    ]),
    _createVNode(Footer)
  ]))
}
}

})